import type { SchedulerTypeKey } from '@jarvis/platform-ui';
import {
  appointmentLifecycleClassName,
  appointmentSyncClassName,
  syncStateAriaLabel,
  type TimeOffSchedulerEvent
} from '../timeOffCalendarTypes';

interface TypeColor {
  id: SchedulerTypeKey;
  color: string;
}

export interface TimeOffCalendarAppointmentProps {
  appointmentData: TimeOffSchedulerEvent;
  typeColors: TypeColor[];
}

export function TimeOffCalendarAppointment({ appointmentData, typeColors }: TimeOffCalendarAppointmentProps) {
  const typeColor =
    typeColors.find((t) => t.id === appointmentData.type)?.color ?? 'var(--ops-color-muted, #64748b)';
  const statusClass = appointmentLifecycleClassName(appointmentData.status, appointmentData.ended);
  const syncClass = appointmentSyncClassName(appointmentData.syncState);
  const syncLabel = syncStateAriaLabel(appointmentData.syncState);
  const cancelled = appointmentData.status === 'Cancelled';
  const title = [
    appointmentData.text,
    cancelled ? 'Cancelled' : appointmentData.ended ? 'Past' : null,
    syncLabel
  ]
    .filter(Boolean)
    .join(' — ');

  return (
    <div
      className={`time-off-appt ${statusClass}`}
      style={{ backgroundColor: typeColor }}
      title={title}
      aria-label={title}
    >
      {cancelled ? (
        <span className="time-off-appt__status-dot time-off-appt__status-dot--cancelled" aria-hidden />
      ) : null}
      {syncClass ? <span className={`time-off-appt__sync ${syncClass}`} aria-hidden /> : null}
      <span className="time-off-appt__label">{appointmentData.text}</span>
    </div>
  );
}
